import { shouldUseSentry } from '../../sentry';
export default {
  name: 'ErrorFallbackErrorPage',
  props: {
    error: {
      type: Error,
      required: true,
      default: ''
    },
    info: {
      type: String,
      required: true,
      default: ''
    },
    element: {
      type: String,
      required: true,
      default: ''
    }
  },
  data() {
    return {
      showErrorDetails: false,
      shouldUseSentry: shouldUseSentry()
    };
  },
  computed: {
    color() {
      return this.$store.state.app.color || '#00a9e1';
    },
    feedbackEmailAddress() {
      return this.$store.state.app.feedbackEmail;
    }
  },
  methods: {
    reload() {
      window.location.reload();
    },
    showDetails() {
      this.showErrorDetails = !this.showErrorDetails;
    },
    getMessageText() {
      return this.$i18n_t('Common.errorboundary.messageNoSentry', {
        mailtoLink: this.getMailToLink(),
        mailtoLinkText: this.feedbackEmailAddress
      });
    },
    getMailToLink() {
      try {
        const subject = `Error report for ${window.location.href}`;
        // remove host from location
        const errorLocation = window.location.href.replace(window.location.origin, '');
        const errorStack = this.error.stack;
        const errorInfo = `${this.info} in ${this.element}`;
        const body = encodeURIComponent(`


========
Error details for "${this.error.message}"
${errorLocation} - ${errorInfo}

${errorStack}
========`);
        return `mailto:${this.feedbackEmailAddress}?subject=${subject}&body=${body}`;
      } catch (error) {
        const subject = `Error report for ${window.location.href}`;
        return `mailto:${this.feedbackEmailAddress}?subject=${subject}`;
      }
    }
  }
};